import { TodoListItem } from '@unmind/design-system';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { useAssetToken } from '../hooks/useAssetToken';
import { useDailyBoost } from '../hooks/useDailyBoost';
import { useTodoListItemTracking } from '../hooks/useTodoListItemTracking';
import { SkeletonItem } from './SkeletonItem';

const DailyBoostItem = () => {
  const { assetToken } = useAssetToken();
  const { t: translate } = useTranslation('homepage', {
    keyPrefix: 'todo_list_section.daily_boost',
  });

  const { tool, trackShortClick, to, durationText, isVideo, loading, error } =
    useDailyBoost('daily-boost-todolist-item');

  const { trackClicked } = useTodoListItemTracking('daily-boost', {
    shown: !loading && !!tool && !error,
    completed: tool?.isCompletedToday ?? false,
  });

  if (loading) {
    return <SkeletonItem />;
  }

  if (!tool || error) {
    return null;
  }

  const path =
    tool.cloudinaryThumbnail?.path && assetToken
      ? `${tool.cloudinaryThumbnail.path}?${assetToken}`
      : undefined;
  const icon = isVideo ? 'video-on' : 'audio';

  return (
    // `titleAsChild` rather than `onClick`: this row navigates, so its control
    // has to be a link. `to` carries router state the tool player reads on
    // close, which a plain `href` string could not.
    <TodoListItem
      titleAsChild
      description={
        tool.estimatedMins == null
          ? tool.title
          : translate('description', {
              title: tool.title,
              duration: durationText,
            })
      }
      descriptionIcon={icon}
      thumbnail={path ? { imageUrl: path } : { icon: icon, tone: 'primary' }}
      cta={translate('cta')}
      completed={tool.isCompletedToday}
    >
      <Link
        to={to}
        onClick={() => {
          trackShortClick();
          trackClicked();
        }}
      >
        {translate('title')}
      </Link>
    </TodoListItem>
  );
};

export default DailyBoostItem;
